import { LookupsComponent } from './../lookups/lookups.component';
import { LookupsRoutes } from './../lookups/routes';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from '../app.component';
import { LoginComponent, CompanySelectorComponent, AuthGuardService, RegisterComponent, AccountCreated, ForgottenPasswordComponent, ResetPasswordComponent, AccountConfirm, CanActivateFalseGuard, RegisterV2Component, LoginV2Component } from 'yt-ng-framework';
import { HomeComponent } from './home/home.component';
import { CompanyRegister } from './company-register/company-register';
import { CompanyRegisterComponent } from './company-register/company-register.component';


const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        pathMatch: 'full',
        canActivate: [AuthGuardService]
    },
    {
        path: 'login',
        //component: LoginComponent
        component: LoginV2Component
    },
    {
        path: 'register',
        //component: LoginComponent
        component: RegisterV2Component
    },
     {
         path: 'admin',
        //  loadChildren: '../admin/admin.module#AdminModule',
         loadChildren: () => import('../admin/admin.module').then(m => m.AdminModule),
         data: {
            breadcrumbLabel: 'admin'
        },
        canActivateChild: [AuthGuardService]
     },
     {
         path: 'mat',
        //  loadChildren: '../mat/mat.module#MatModule',
        loadChildren: () => import('../mat/mat.module').then(m => m.MatModule),
         data: {
             breadcrumbLabel: 'materijalno'
         },
         canActivateChild: [AuthGuardService]
     },
     {
        path: 'kad',
        // loadChildren: '../kad/kad.module#KadModule',
        loadChildren: () => import('../kad/kad.module').then(m => m.KadModule),
        data: {
            breadcrumbLabel: 'kadrovska'
        },
        canActivateChild: [AuthGuardService]
    },
    {
        path: 'fin',
        // loadChildren: '../fin/fin.module#FinModule',
        loadChildren: () => import('../fin/fin.module').then(m => m.FinModule),
        data: {
            breadcrumbLabel: 'finansije'
        },
        canActivateChild: [AuthGuardService]
    },
    {
        path: 'lookups',
        component: LookupsComponent,
        children: 
            LookupsRoutes,
        data: {
            breadcrumbLabel: 'ŠIFARNICI'
        },
        canActivateChild: [AuthGuardService]
        
    },
    {
        path: 'fak',
        // loadChildren: '../fak/fak.module#FakModule',
        loadChildren: () => import('../fak/fak.module').then(m => m.FakModule),
        data: {
            breadcrumbLabel: 'fakturisanje'
        },
        canActivateChild: [AuthGuardService]
        
    },
    {
        path: 'eotpremnice',
        loadChildren: () => import('../eotpremnice/eotpremnice.module').then(m => m.EOtpremnicaModule),
        data: {
            breadcrumbLabel: 'e-otpremnice'
        }
        , canActivateChild: [AuthGuardService]
    },
    {
        path: 'epdv',
        // loadChildren: '../epdv/epdv.module#EPdvModule',
        loadChildren: () => import('../epdv/epdv.module').then(m => m.EPdvModule),
        data: {
            breadcrumbLabel: 'epdv'
        },
        canActivateChild: [AuthGuardService]
    },
    {
        path: 'yt-xchange',
        // loadChildren: '../yt-xchange/yt-xchange.module#YtXChangeModule',
        loadChildren: () => import('../yt-xchange/yt-xchange.module').then(m => m.YtXChangeModule),
        data: {
            breadcrumbLabel: 'menjačnica'
        },
        canActivateChild: [AuthGuardService]
    },
    {
        path: 'company-selector',
        component: CompanySelectorComponent,
        pathMatch: 'full',
        canActivate: [AuthGuardService]
    },
    {
        path: 'korisnicki-nalog-kreiran',
        component: AccountCreated,
        pathMatch: 'full'
    },
    {
        path: 'forgotten-password',
        component: ForgottenPasswordComponent,
        pathMatch: 'full'
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent,
        pathMatch: 'full'
    },
    {
        path: 'account-confirm',
        component: AccountConfirm
    },
    {
        path: 'firma-register',
        component: AppComponent,
        pathMatch: 'full',
        canActivate: [CanActivateFalseGuard],
        data: {
            mainList: {
                modelName: 'firma',
                modelClass: CompanyRegister,
                defaultPropertyName: 'Naziv',
                formType: 'reactive'
            },
            updateComponent: CompanyRegisterComponent,
            modalSize: 'lg'
        }
    },
    {
        path: 'efakture',
        // loadChildren: '../efakture/efakture.module#EfaktureModule',
        loadChildren: () => import('../efakture/efakture.module').then(m => m.EfaktureModule),
        data: {
            breadcrumbLabel: 'efakture'
        },
        canActivateChild: [AuthGuardService]
    },
   {
        path: '**',
        component: AppComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true})],
    exports: [RouterModule]
})
export class CoreRoutingModule { }
